module.exports = __webpack_public_path__ + "img/dianjiyun3.089f5f68.png";